module.exports = __webpack_public_path__ + "static/media/border-style.708f84e8.svg";